/**
 *
 * @param str
 * @param delimiter
 * @returns undefined if str is falsy, otherwise substring to first index of delimiter or the end
 */
export function extractId(str?: string, delimiter = "-"): string | undefined {
  return str ? str.split(delimiter)[0] : undefined;
}

/**
 * Immutably sets the noOverlay state on optionally provided object
 * @param state
 */
export function addNoOverlayState(state?: object) {
  return { ...state, noOverlay: true };
}
